import React from "react";
import { categories } from "../../../../data/businessListing/categories";
import FilterTitle from "../../../Category/Filter/Common/FilterTitle";
import Text from "../../../Category/Filter/Common/Text";

const Categories = () => {
  return (
    <div className="border-b border-darkGreen border-opacity-40 px-7 py-8">
      <FilterTitle title={"Categories"} />
      <div className="mb-2 flex flex-col gap-4 ">
        {categories.map((category) => (
          <Text
            key={category.id}
            text={category.name}
            amount={category.quantity}
          />
        ))}
      </div>
    </div>
  );
};

export default Categories;
